export enum Sfx {
  POWER_ON = 'click',
  SWITCH = 'switch',
  TOGGLE_OFF = 'toggle-off',
  TOGGLE_ON = 'toggle-on',
  SMALL_MOTOR = 'small-motor',
}
